import whiteLabelContent from '../content/white-label.json';
import { standardProjectTypes } from './standardCapabilities';
import { getWorkBySlug, type WorkItem } from './work';

export const whiteLabelProjectTypes = [
  ...standardProjectTypes,
  'other-code-first',
] as const;

export const whiteLabelEngagementModes = [
  'figma-to-build',
  'design-and-build',
  'not-sure',
] as const;

export type WhiteLabelProjectType = (typeof whiteLabelProjectTypes)[number];
export type WhiteLabelEngagementMode = (typeof whiteLabelEngagementModes)[number];

interface WhiteLabelAudience { title: string; summary: string; points: string[]; }
interface WhiteLabelEngagementCard { value: Exclude<WhiteLabelEngagementMode, 'not-sure'>; title: string; summary: string; }
interface WhiteLabelRate { value: Exclude<WhiteLabelProjectType, 'other-code-first'>; name: string; prefix: 'from'; startingPriceUsd: number; summary: string; }
interface WhiteLabelFaq { question: string; answer: string; }

export interface WhiteLabelContent {
  hero: { eyebrow: string; title: string; proposition: string; lead: string; primaryCta: string; secondaryCta: string; ratesCta: string; trustLine: string[]; };
  agencyBenefits: Array<{ title: string; text: string }>;
  audiences: WhiteLabelAudience[];
  engagementModes: WhiteLabelEngagementCard[];
  developmentOnlyNote: string;
  deliverySteps: Array<{ number: string; title: string; description: string }>;
  projectTypes: WhiteLabelRate[];
  buildCapabilities: string[];
  ratesIntro: string;
  otherProjectsNote: string;
  stack: { title: string; lead: string; items: string[]; note: string };
  selectedWorkSlugs: string[];
  selectedWork: { eyebrow: string; title: string; text: string };
  principles: Array<{ title: string; text: string }>;
  paymentNote: string;
  collaboration: { title: string; brief: string; body: string; linkLabel: string };
  bestFitPartners: string[];
  ndaNote: string;
  faq: WhiteLabelFaq[];
  form: { eyebrow: string; title: string; lead: string; submitLabel: string; submittingLabel: string; successMessage: string; microcopy: string; };
  whatsappMessage: string;
  seo: { title: string; description: string };
}

export const whiteLabelConfig = whiteLabelContent as WhiteLabelContent;

export function getWhiteLabelSelectedWork(): WorkItem[] {
  return whiteLabelConfig.selectedWorkSlugs.map((slug) => {
    const item = getWorkBySlug(slug);
    if (!item) throw new Error(`White-label selected Work item is missing or unpublished: ${slug}`);
    return item;
  });
}
